var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "modelscr-container": true, hasTagsView: _vm.needTagsView } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("common." + _vm.dialogStatus),
            width: _vm.width,
            visible: _vm.isVisible,
            "modal-append-to-body": false,
            "close-on-click-modal": false,
            "destroy-on-close": true,
            "before-close": _vm.clickCloseBtn,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isVisible = $event
            },
            closed: _vm.closeFunc,
          },
        },
        [
          _c(
            "div",
            { style: _vm.styleObject },
            [_c("el-scrollbar", [_vm._t("default")], 2)],
            1
          ),
          _vm._v(" "),
          _vm.isOnlyConfirm
            ? _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "info", size: "small" },
                      on: { click: _vm.clickCancel },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _vm._t("footer-btn-left"),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "info", size: "small" },
                      on: { click: _vm.clickCancel },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                  ),
                  _vm._v(" "),
                  _vm._t("footer-btn-center"),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.clickSave },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  ),
                ],
                2
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }